export const userStyles = {
  container: {
    padding: '20px',
  },
};
